/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The Address model module.
 * @module model/Address
 * @version 1.0.0
 */
class Address {
    /**
     * Constructs a new <code>Address</code>.
     * @alias module:model/Address
     * @param country {String} 
     * @param postalCode {String} 
     * @param city {String} 
     * @param region {String} Provincia
     * @param streetType {String} Tipo de vía
     * @param address {String} 
     */
    constructor(country, postalCode, city, region, streetType, address) { 
        
        Address.initialize(this, country, postalCode, city, region, streetType, address);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, country, postalCode, city, region, streetType, address) { 
        obj['country'] = country;
        obj['postal_code'] = postalCode;
        obj['city'] = city;
        obj['region'] = region;
        obj['street_type'] = streetType;
        obj['address'] = address;
    }

    /**
     * Constructs a <code>Address</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Address} obj Optional instance to populate.
     * @return {module:model/Address} The populated <code>Address</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Address();

            if (data.hasOwnProperty('country')) {
                obj['country'] = ApiClient.convertToType(data['country'], 'String');
            }
            if (data.hasOwnProperty('postal_code')) {
                obj['postal_code'] = ApiClient.convertToType(data['postal_code'], 'String');
            }
            if (data.hasOwnProperty('city')) {
                obj['city'] = ApiClient.convertToType(data['city'], 'String');
            }
            if (data.hasOwnProperty('region')) {
                obj['region'] = ApiClient.convertToType(data['region'], 'String');
            }
            if (data.hasOwnProperty('street_type')) {
                obj['street_type'] = ApiClient.convertToType(data['street_type'], 'String');
            }
            if (data.hasOwnProperty('street_number')) {
                obj['street_number'] = ApiClient.convertToType(data['street_number'], 'String');
            }
            if (data.hasOwnProperty('address')) {
                obj['address'] = ApiClient.convertToType(data['address'], 'String');
            }
            if (data.hasOwnProperty('floor_door')) {
                obj['floor_door'] = ApiClient.convertToType(data['floor_door'], 'String');
            }
            if (data.hasOwnProperty('extra_address')) {
                obj['extra_address'] = ApiClient.convertToType(data['extra_address'], 'String');
            }
            if (data.hasOwnProperty('polygon')) {
                obj['polygon'] = ApiClient.convertToType(data['polygon'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} country
 */
Address.prototype['country'] = undefined;

/**
 * @member {String} postal_code
 */
Address.prototype['postal_code'] = undefined;

/**
 * @member {String} city
 */
Address.prototype['city'] = undefined;

/**
 * Provincia
 * @member {String} region
 */
Address.prototype['region'] = undefined;

/**
 * Tipo de vía
 * @member {String} street_type
 */
Address.prototype['street_type'] = undefined;

/**
 * @member {String} street_number
 */
Address.prototype['street_number'] = undefined;

/**
 * @member {String} address
 */
Address.prototype['address'] = undefined;

/**
 * @member {String} floor_door
 */
Address.prototype['floor_door'] = undefined;

/**
 * @member {String} extra_address
 */
Address.prototype['extra_address'] = undefined;

/**
 * @member {String} polygon
 */
Address.prototype['polygon'] = undefined;






export default Address;

